import React from 'react'

import { AppearingWrapper, SectionContainer } from 'Components/Blocks'
import { Column } from 'Components/UI'

import Questions from './Questions'

function ExecutiveInviteQuestionSection() {
  return (
    <SectionContainer>
      <AppearingWrapper centered>
        <Column fullWidth>
          <Questions />
        </Column>
      </AppearingWrapper>
    </SectionContainer>
  )
}

export default ExecutiveInviteQuestionSection
